import { BodyText } from "../../lib/ui/components/typography/Typography";

/** Label + control stack for digest settings (body-size label, design-system control). */
export default function DigestFormField({ label, htmlFor, className = "", children }) {
  return (
    <label
      htmlFor={htmlFor}
      className={`flex flex-col gap-1 ${className}`.trim()}
    >
      <BodyText weight="medium" emphasis className="!mb-0">
        {label}
      </BodyText>
      {children}
    </label>
  );
}
